module.exports = __webpack_public_path__ + "static/banner-maintenance-7b5fae112f5892bbc3d1fc4fa37ef366.png";